import Projectscont from '../../components/Project/projectscont';
import { MainLayout } from '../../components/Layout';

const Project = ({ collapsed, setCollapsed }) => {
  return (
    <MainLayout collapsed={collapsed} setCollapsed={setCollapsed}>
      <Projectscont />
    </MainLayout>
  );
};

export default Project;
